import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { map, Observable } from 'rxjs';
import { NotificationService } from '../../_services/notification.service';
import { UserService } from '../../_services/user.service';
import { SubscriptionSwopDeviceDialogComponent } from 'src/app/features/portal-management/components/subscriptions/subscription-swop-device-dialog/subscription-swop-device-dialog.component';
import { PortalManagementSubscriptionService } from 'src/app/features/portal/_services/management/portal-management-subscription.service';

@Component({
  selector: 'app-share-circuit-action-bar',
  templateUrl: './share-circuit-action-bar.component.html',
  styleUrls: ['./share-circuit-action-bar.component.scss']
})
export class ShareCircuitActionBarComponent implements OnInit {
  @Input() customerCircuit: any;
  @Input() subscriptionId!: number;
  @Input() onRefresh?: () => void;
  currentUser$: Observable<any> = this.us.currentUser$;
  userRole: any;
  loadingDeviceSwop: boolean = false;

  constructor(
    public ns: NotificationService,
    private ds: DialogService,
    private us: UserService,
    public cs: ConfirmationService,
    private pmss: PortalManagementSubscriptionService
  ) {}

  ngOnInit(): void {
    this.currentUser$
      .pipe(
        map((user) => {
          this.userRole = user?.role;
          return user;
        })
      )
      .subscribe();
  }

  showDeviceSwopDialog(rowData: any, $event: Event) {
    this.loadingDeviceSwop = true;
    const ref = this.ds.open(SubscriptionSwopDeviceDialogComponent, {
      data: {
        customerCircuit: rowData
      },
      modal: true,
      showHeader: true,
      header: 'Device Swop',
      width: '60%'
    });

    ref.onClose.subscribe((res: any) => {
      if (!res || !res.new_device_serial_number) {
        this.loadingDeviceSwop = false;
        return;
      }

      this.pmss.changeSubscriptionDevice(this.subscriptionId, res.new_device_serial_number).subscribe({
        next: () => {
          this.ns.mainSuccess('Device swopped successfully');
          this.onRefresh?.();
          this.loadingDeviceSwop = false;
        },
        error: (err: any) => {
          this.ns.mainError('Failed to swop device: ' + err.message);
          this.loadingDeviceSwop = false;
        }
      });
    });
  }
}
